document.addEventListener("DOMContentLoaded",function(){
    init();
});

const init = () => {
    initiateTbhTestimonialSlider();
};

/*
    Slider
*/
const initiateTbhTestimonialSlider = () => {
    
    var flickityTestimonialSliderEl = document.querySelector('.tbh-slider--testimonials');
    if(flickityTestimonialSliderEl) {
        var flkty = new Flickity( flickityTestimonialSliderEl, {
            /*
                Options
            */
            cellAlign: 'center',
            autoPlay: 4000,
            pageDots: false
        });
    }
};
